import axios from "axios";
export const HTTP = axios.create({
    baseURL:window.VUE_CONFIG_API,
})

export const HTTPTerminal = axios.create({
    baseURL:window.TERMINAL_URL,
})